export const tableColumnList = [
  {
    field: 'expenseTypeName', // 1
    title: '费用类型',
    // width: '120',
  },
  {
    field: 'instructionNo',
    title: '指令单编号',
    // width: '150',
  },
  // {
  //   field: 'multiBillingRuleFlag',
  //   title: '是否存在多个计费规则',
  //   width: '150',
  // },
  // {
  //   field: 'contractNo',
  //   title: '计费规则来源（合同编号）',
  //   width: '170',
  // },
  {
    field: 'originalPrice',
    title: '结算单价(含税)',
    // width: '140',
  },
  {
    field: 'statementQuantity',
    title: '结算数量',
    // width: '140',
  },
  {
    field: 'unitName',
    title: '计量单位',
    // width: '140',
  },
  {
    field: 'originalAmount',
    title: '结算金额(含税)',
    // width: '140',
  },
  {
    field: 'remark',
    title: '备注',
    // width: '140',
  },
  // {
  //   field: 'exchangeRate',
  //   title: '汇率',
  //   width: '140',
  // },
  // {
  //   field: 'domesticAmount',
  //   title: '本币结算金额(含税)',
  //   width: '140',
  //   editRender: { name: 'domesticAmount' },
  // },
  // {
  //   field: 'adjustOriginalPrice',
  //   title: '调整原币结算单价(含税)',
  //   width: '160',
  //   editRender: { name: 'adjustOriginalPrice' },
  // },
  // {
  //   field: 'adjustStatementQuantity',
  //   title: '调整结算数量',
  //   width: '140',
  //   editRender: { name: 'adjustStatementQuantity' },
  // },
  // {
  //   field: 'adjustOriginalAmount',
  //   title: '调整原币结算金额(含税)',
  //   width: '170',
  //   editRender: { name: 'adjustOriginalAmount' },
  // },

  // {
  //   field: 'adjustDomesticAmount',
  //   title: '调整本币结算金额(含税)',
  //   width: '170',
  //   editRender: { name: 'adjustDomesticAmount' },
  // },
  // {
  //   field: 'adjustReason',
  //   title: '调整原因',
  //   width: '140',
  //   editRender: { name: 'adjustReason' },
  // },
];

export const tableRules = {
  // expenseType: [{ required: true, message: '必填字段' }],
  // instructionNo: [{ required: true, message: '必填字段' }],
  originalPrice: [{ required: true, message: '必填字段' }],
  statementQuantity: [{ required: true, message: '必填字段' }],
  unit: [{ required: true, message: '必填字段' }],
  originalAmount: [{ required: true, message: '必填字段' }],
  // contractNo: [{ required: true, message: '必填字段' }],
};
